// extracted by mini-css-extract-plugin
export var infoItem = "_qr-2";
export var title = "_qr-0";
export var value = "_qr-1";